import { render, staticRenderFns } from "./nuxt-img.vue?vue&type=template&id=4c03b41d&"
import script from "./nuxt-img.vue?vue&type=script&lang=js&"
export * from "./nuxt-img.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports